(function () {
  'use strict';

  function TabbedFeaturedCollections(container) {
    this.container = container;
    this.genderBtns = Array.from(container.querySelectorAll('.tabbed-featured-collections__gender-btn'));
    this.initializedPanels = new Set();
    this.activeGender = 'men';

    this._initActivePanel();
    this._bindEvents();
  }

  TabbedFeaturedCollections.prototype._buildSwiperConfig = function (panel) {
    var outer = panel.parentElement;
    var prevBtn = outer.querySelector('.tabbed-featured-collections__nav-btn--prev');
    var nextBtn = outer.querySelector('.tabbed-featured-collections__nav-btn--next');

    return {
      slidesPerView: 4,
      spaceBetween: 25,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.9,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    };
  };

  TabbedFeaturedCollections.prototype._initSwiper = function (panel) {
    if (!panel || this.initializedPanels.has(panel.id)) return;

    if (typeof Swiper === 'undefined') {
      console.warn('TabbedFeaturedCollections: Swiper is not loaded.');
      return;
    }

    new Swiper(panel, this._buildSwiperConfig(panel));
    this.initializedPanels.add(panel.id);
  };

  TabbedFeaturedCollections.prototype._initActivePanel = function () {
    var activePanel = this.container.querySelector('.tabbed-featured-collections__panel--active');
    if (activePanel) {
      this._initSwiper(activePanel);
    }
  };

  TabbedFeaturedCollections.prototype._bindEvents = function () {
    var self = this;

    this.genderBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._switchGender(btn.dataset.genderTarget);
      });
    });

    this.container
      .querySelectorAll('.tabbed-featured-collections__tab')
      .forEach(function (tab) {
        tab.addEventListener('click', function () {
          self._switchTab(tab);
        });
      });
  };

  TabbedFeaturedCollections.prototype._switchGender = function (gender) {
    if (!gender || gender === this.activeGender) return;

    this.activeGender = gender;

    this.genderBtns.forEach(function (btn) {
      var isActive = btn.dataset.genderTarget === gender;
      btn.classList.toggle('tabbed-featured-collections__gender-btn--active', isActive);
      btn.setAttribute('aria-selected', String(isActive));
    });

    this.container
      .querySelectorAll('[data-gender-group]')
      .forEach(function (group) {
        group.hidden = group.dataset.genderGroup !== gender;
      });

    var activePanel = this.container.querySelector(
      '.tabbed-featured-collections__panels-group[data-gender-group="' + gender + '"] .tabbed-featured-collections__panel--active'
    );
    this._initSwiper(activePanel);
  };

  TabbedFeaturedCollections.prototype._switchTab = function (clickedTab) {
    var targetSelector = clickedTab.dataset.tabTarget;
    if (!targetSelector) return;

    var targetPanel = this.container.querySelector(targetSelector);
    if (!targetPanel) return;
    if (targetPanel.classList.contains('tabbed-featured-collections__panel--active')) return;

    var tabGroup = clickedTab.closest('[data-gender-group]');
    var gender = tabGroup ? tabGroup.dataset.genderGroup : null;

    this.container
      .querySelectorAll('.tabbed-featured-collections__tabs[data-gender-group="' + gender + '"] .tabbed-featured-collections__tab')
      .forEach(function (tab) {
        var isActive = tab === clickedTab;
        tab.classList.toggle('tabbed-featured-collections__tab--active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

    var panelsGroup = this.container.querySelector(
      '.tabbed-featured-collections__panels-group[data-gender-group="' + gender + '"]'
    );
    if (panelsGroup) {
      panelsGroup
        .querySelectorAll('.tabbed-featured-collections__panel')
        .forEach(function (panel) {
          panel.classList.remove('tabbed-featured-collections__panel--active');
        });
      panelsGroup
        .querySelectorAll('.tabbed-featured-collections__panel-outer')
        .forEach(function (outer) {
          outer.classList.remove('tabbed-featured-collections__panel-outer--active');
        });
    }
    targetPanel.classList.add('tabbed-featured-collections__panel--active');
    targetPanel.parentElement.classList.add('tabbed-featured-collections__panel-outer--active');

    var footerGroup = this.container.querySelector(
      '.tabbed-featured-collections__footer[data-gender-group="' + gender + '"]'
    );
    var targetPanelId = targetPanel.id;
    if (footerGroup) {
      footerGroup
        .querySelectorAll('.tabbed-featured-collections__shop-all')
        .forEach(function (link) {
          var isActive = link.dataset.panelId === targetPanelId;
          link.classList.toggle('tabbed-featured-collections__shop-all--active', isActive);
        });
    }

    this._initSwiper(targetPanel);
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tabbed-featured-collections[data-section-id]').forEach(function (container) {
      new TabbedFeaturedCollections(container);
    });
  });
})();
